import React, { useCallback, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Label } from "reactstrap";
import {
  Typography,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  TextField,
  Grid,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  Switch,
} from "@mui/material";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EditIcon from "@mui/icons-material/Edit";
// import SendIcon from "@material-ui/icons/Send";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
// import ExtendIcon from "@material-ui/icons/AccessTime";
import ExtendIcon from "@mui/icons-material/AccessTime";
// import IaacIcon from "@material-ui/icons/AssignmentInd";
import IaacIcon from "@mui/icons-material/AssignmentInd";
// import OutboundIcon from "@mui/icons-material/Outbound";
import OutboundIcon from "@mui/icons-material/Outbound";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import BillingIcon from "@mui/icons-material/AttachMoney";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Row, Col, FormGroup, Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import PhoneInput, { isPossiblePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import spinner from "../../assets/images/loadingGif.gif";
import { countryList, getRegionCode } from "../../utilities/countries";

import {
  addOrganization,
  getOrganizations,
  getPreOnBoardedOrganizations,
  resendOrgOnBoardActionLink,
  updateOrganization,
  deleteOrganization,
  clearAllMessages,
  registerTrialAccountUser,
  extendFreeLicense,
  clearAllFreeLicenseMessages,
} from "../../store/actions";

import { Link as RouterLink } from "react-router-dom";
import accessToken from "../../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";
import OrganizationTable from "./OrganizationTable";
import styles from "./OrganizationTable.module.css";

import PreOnboardedOrganizationsTable from "./PreOnboardedOrganizations/PreOnboardedOrganizationsTable";

import { makeStyles } from "@mui/styles";
import Modal from "@mui/material/Modal";
import { validateAddressWithAPI } from "../../helpers/addressValidation";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white",
    marginLeft: "auto",
    textDecoration: "none",
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "8px",
    maxHeight: "90vh",
    overflow: "auto",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  title: {
    flex: 1,
    marginRight: theme.spacing(2),
  },
  closeButton: {
    marginLeft: "auto",
    marginRight: -12,
    marginTop: -12,
  },
  actions: {
    display: "flex",
    gap: "0.25rem",
  },
}));

const updateOrgEmptyFormState = {
  orgname: null,
  orgprimaryname: null,
  orgaddress: null,
  orgcity: null,
  orgstate: null,
  orgcountry: null,
  orgzip: null,
  orgbillingname: null,
  orgbillingaddress: null,
  orgbillingstate: null,
  orgbillingcountry: null,
  orgbillingzip: null,
  orgbillingcity: null,
  phoneNumber: null,
  numUsers: null,
  numAccounts: null,
  orgScopeEnabled: null,
};

const Organization = (props) => {
  const appBarStyles = {
    backgroundColor: "whitesmoke",
    // Add more custom styles as needed
  };
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userRole = decoded["cognito:groups"];

  const classes = useStyles();
  const [selectedOrg, setSelectedOrg] = useState(null);

  const history = useHistory();

  //Form State for Update Organization
  const [updateOrgFormState, setUpdateOrgFormState] = useState(
    updateOrgEmptyFormState
  );
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);

  // Form State variables
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [phonenumberError, setPhonenumberError] = useState("");

  const [userEmail, setUserEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [userCountry, setUserCountry] = useState("");
  const [userComments, setUserComments] = useState("");
  const [noOfAccounts, setNoOfAccounts] = useState("");
  const [noOfUsers, setNoOfUsers] = useState("");
  const [registrationType, setRegistrationType] = useState("");

  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [tabIndex, setTabIndex] = React.useState(0);

  // State variables for extending the free license by days
  const [extendLicenseDialogOpen, setExtendLicenseDialogOpen] = useState(false);
  const [extendDays, setExtendDays] = useState("");
  const [orgCodeForExtendLicense, setOrgCodeForExtendLicense] = useState("");

  // First, add a state to track the organization to be deleted
  const [orgToDelete, setOrgToDelete] = useState(null);

  const [addressValidationStatus, setAddressValidationStatus] = useState(null);
  const [addressValidationMessage, setAddressValidationMessage] = useState("");
  const [validatedAddress, setValidatedAddress] = useState(null);

  // Add new state variables for update modal address validation
  const [updateAddressValidationStatus, setUpdateAddressValidationStatus] = useState(null);
  const [updateAddressValidationMessage, setUpdateAddressValidationMessage] = useState("");
  const [updateValidatedAddress, setUpdateValidatedAddress] = useState(null);
  const [updateBillingAddressValidationStatus, setUpdateBillingAddressValidationStatus] = useState(null);
  const [updateBillingAddressValidationMessage, setUpdateBillingAddressValidationMessage] = useState("");
  const [updateValidatedBillingAddress, setUpdateValidatedBillingAddress] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const clearAddFormState = () => {
    setUserFirstName("");
    setUserLastName("");
    setUserPhone("");
    setUserEmail("");
    setCompanyName("");
    setUserAddress("");
    setUserCountry("");
    setUserComments("");
    setNoOfAccounts("");
    setNoOfUsers("");
    setRegistrationType("");
  };

  const clearUpdateFormState = () => {
    setUpdateOrgFormState(updateOrgEmptyFormState);
  };

  const clearExtendLicenseFormState = () => {
    setExtendDays("");
    setOrgCodeForExtendLicense("");
  };

  useEffect(() => {
    props.getOrganizations();
  }, []);

  //For displaying message for register trial account user
  let trialAccMsg = props.registerTrialAccountUserMessage;
  useEffect(() => {
    console.log("trialAccMsg = " + trialAccMsg);
    if (trialAccMsg) {
      console.log("Inside if, trialAccMsg = " + trialAccMsg);
      //Close Modal
      setAddDialogOpen(false);
      //Clear state variables associated with the form
      clearAddFormState();
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [trialAccMsg, props]);

  //For displaying message for getting organizations
  let getOrgsMsg = props.getOrganizationsMessage;
  useEffect(() => {
    console.log("getOrgsMsg = " + getOrgsMsg);
    if (getOrgsMsg) {
      console.log("Inside if, getOrgsMsg = " + getOrgsMsg);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [getOrgsMsg, props]);

  //For displaying message for getting pre on boarded organizations
  let getPreOnBoardedOrganizationsMessage =
    props.getPreOnBoardedOrganizationsMessage;
  useEffect(() => {
    console.log(
      "getPreOnBoardedOrganizationsMessage = " +
        getPreOnBoardedOrganizationsMessage
    );
    if (getPreOnBoardedOrganizationsMessage) {
      console.log(
        "Inside if, getPreOnBoardedOrganizationsMessage = " +
          getPreOnBoardedOrganizationsMessage
      );
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [getPreOnBoardedOrganizationsMessage, props]);

  //For displaying message for resending org on board activation link
  let resendOrgOnBoardActivationLinkMessage =
    props.resendOrgOnBoardActivationLinkMessage;
  useEffect(() => {
    console.log(
      "resendOrgOnBoardActivationLinkMessage = " +
        resendOrgOnBoardActivationLinkMessage
    );
    if (resendOrgOnBoardActivationLinkMessage) {
      console.log(
        "Inside if, resendOrgOnBoardActivationLinkMessage = " +
          resendOrgOnBoardActivationLinkMessage
      );
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [resendOrgOnBoardActivationLinkMessage, props]);

  //For displaying message for updating organization
  let updateOrganizationMsg = props.updateOrganizationMessage;
  useEffect(() => {
    console.log("updateOrganizationMsg = " + updateOrganizationMsg);
    if (updateOrganizationMsg) {
      console.log(
        "Inside if, updateOrganizationMsg = " + updateOrganizationMsg
      );
      //Close Modal
      setUpdateDialogOpen(false);
      //Clear state variables associated with the form
      clearUpdateFormState();
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [updateOrganizationMsg, props]);

  //For displaying message for delete organization
  let deleteOrganizationMsg = props.deleteOrganizationMessage;
  useEffect(() => {
    console.log("deleteOrganizationMsg = " + deleteOrganizationMsg);
    if (deleteOrganizationMsg) {
      console.log(
        "Inside if, deleteOrganizationMsg = " + deleteOrganizationMsg
      );
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [deleteOrganizationMsg, props]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Update the handleDeleteClick function
  const handleDeleteClick = (org) => {
    setOrgToDelete(org); // Store the organization object
    setShowDeleteModal(true);
  };

  // Update the closeDeleteModal function
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setOrgToDelete(null); // Clear the stored organization
  };

  // Update the handleDeleteConfirm function
  const handleDeleteConfirm = () => {
    if (orgToDelete) {
      console.log("🚀 ~ handleDeleteConfirm ~ orgToDelete:", orgToDelete.orgcode)
      props.deleteOrganization(orgToDelete.orgcode);
    }
    handleCloseDeleteModal();
  };

  // For Opening Add Organization Modal
  const handleAddModalOpen = () => {
    setAddDialogOpen(true);
  };

  // For Closing Add Organization Modal
  const handleAddModalClose = () => {
    setAddDialogOpen(false);
    clearAddFormState();
    props.clearAllMessages();
  };

  // For handling form fields of Organization Modal
  const handleAddOrgInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "userFirstName") {
      setUserFirstName(value);
    } else if (name === "userLastName") {
      setUserLastName(value);
    } else if (name === "userEmail") {
      setUserEmail(value);
    } else if (name === "companyName") {
      setCompanyName(value);
    } else if (name === "userAddress") {
      setUserAddress(value);
    } else if (name === "userCountry") {
      setUserCountry(value);
    } else if (name === "userComments") {
      setUserComments(value);
    } else if (name === "noOfAccounts") {
      setNoOfAccounts(value);
    } else if (name === "noOfUsers") {
      setNoOfUsers(value);
    } else if (name === "registrationType") {
      setRegistrationType(value);
    }
  };

  // For handling userPhone using PhoneInput component
  const handlePhoneChange = (value) => {
    setUserPhone(value);
  };

  const handlePhoneBlur = () => {
    let isInvalidResult;
    if (!userPhone) {
      isInvalidResult = true;
    } else {
      isInvalidResult = !isPossiblePhoneNumber(userPhone);
    }
    if (isInvalidResult) {
      setPhonenumberError("Please enter a valid phone number");
    } else {
      setPhonenumberError(null);
    }
  };

  // For Validating form of Organization Modal
  const isAddOrgFormInvalid = () => {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
    const isInvalidItems = [
      {
        field: "userFirstName",
        isInvalid: userFirstName === "" ? true : false,
      },
      {
        field: "userLastName",
        isInvalid: userLastName === "" ? true : false,
      },
      {
        field: "userEmail",
        isInvalid:
          (userEmail && userEmail.length === 0) ||
          !regex.test(String(userEmail).toLowerCase()),
      },
      {
        field: "registrationType",
        isInvalid: registrationType === "" ? true : false,
      },
      {
        field: "userAddress",
        isInvalid: userAddress.length === 0 ? true : false,
      },
      {
        field: "noOfUsers",
        isInvalid: noOfUsers.length === 0 ? true : false,
      },
      {
        field: "noOfAccounts",
        isInvalid: noOfAccounts.length === 0 ? true : false,
      },
    ];
    const resp = isInvalidItems.filter((item) => item.isInvalid);
    // console.log(
    //   "--== isInvalid <:::> phonenumber ",
    //   this.state.phonenumber,
    //   isInvalidItems,
    //   resp
    // );

    return resp.length > 0;
  };

  const validateAddress = async (address, country, type = 'primary') => {
    if (!address?.trim() || !country) return;

    // Set initial validation states based on address type
    if (type === 'primary') {
      setAddressValidationStatus(null);
      setAddressValidationMessage("Validating address...");
    } else if (type === 'update-primary') {
      setUpdateAddressValidationStatus(null);
      setUpdateAddressValidationMessage("Validating address...");
    } else if (type === 'update-billing') {
      setUpdateBillingAddressValidationStatus(null);
      setUpdateBillingAddressValidationMessage("Validating address...");
    }

    const regionCode = getRegionCode(country);
    if (!regionCode) {
      const message = "Please select a valid country first";
      if (type === 'primary') {
        setAddressValidationStatus("invalid");
        setAddressValidationMessage(message);
      } else if (type === 'update-primary') {
        setUpdateAddressValidationStatus("invalid");
        setUpdateAddressValidationMessage(message);
      } else if (type === 'update-billing') {
        setUpdateBillingAddressValidationStatus("invalid");
        setUpdateBillingAddressValidationMessage(message);
      }
      return;
    }

    try {
      const result = await validateAddressWithAPI(
        address,
        regionCode,
        process.env.REACT_APP_GOOGLE_MAPS_API_KEY
      );

      if (type === 'primary') {
        setAddressValidationStatus(result.isValid ? "valid" : "invalid");
        setAddressValidationMessage(result.message);
        if (result.isValid) {
          setValidatedAddress(result);
        }
      } else if (type === 'update-primary') {
        setUpdateAddressValidationStatus(result.isValid ? "valid" : "invalid");
        setUpdateAddressValidationMessage(result.message);
        if (result.isValid) {
          setUpdateValidatedAddress(result);
        }
      } else if (type === 'update-billing') {
        setUpdateBillingAddressValidationStatus(result.isValid ? "valid" : "invalid");
        setUpdateBillingAddressValidationMessage(result.message);
        if (result.isValid) {
          setUpdateValidatedBillingAddress(result);
        }
      }
      
      return result;
    } catch (error) {
      const message = "Failed to validate address. Please try again.";
      if (type === 'primary') {
        setAddressValidationStatus("invalid");
        setAddressValidationMessage(message);
      } else if (type === 'update-primary') {
        setUpdateAddressValidationStatus("invalid");
        setUpdateAddressValidationMessage(message);
      } else if (type === 'update-billing') {
        setUpdateBillingAddressValidationStatus("invalid");
        setUpdateBillingAddressValidationMessage(message);
      }
      return null;
    }
  };

  //For Submitting data of Add Organization to API
  const handleAddOrgFormSubmit = async (e) => {
    e.preventDefault();
    let valid = true;
    let newTrialUser = null;
    
    // Validate address if not already validated
    if (!validatedAddress) {
      const validationResult = await validateAddress(userAddress, userCountry);
      if (!validationResult || !validationResult.isValid) {
        return;
      }
    }

    // Data validation
    valid = !isAddOrgFormInvalid();
    newTrialUser = {
      firstName: userFirstName,
      lastName: userLastName,
      phoneNumber: userPhone,
      email: userEmail,
      workAddress: validatedAddress.formattedAddress || userAddress,
      zipcode: validatedAddress.zip,
      city: validatedAddress.city,
      province: validatedAddress.state,
      country: userCountry,
      company: companyName,
      comments: userComments,
      maxusers: noOfUsers,
      maxacounts: noOfAccounts,
      registrationtype: registrationType,
    };

    if (valid) {
      console.log("About to send newTrialUser to API :: ", newTrialUser);
      props.registerTrialAccountUser(newTrialUser);
    }
  };

  // For Opening Update Organization Modal
  const handleUpdateModalOpen = (rowData) => {
    console.log("handleUpdateModalOpen, Row Data :: ", rowData);
    let row = { ...rowData };
    setUpdateOrgFormState(row);
    setUpdateDialogOpen(true);
    // Reset validation states
    setUpdateAddressValidationStatus(null);
    setUpdateAddressValidationMessage("");
    setUpdateValidatedAddress(null);
    setUpdateBillingAddressValidationStatus(null);
    setUpdateBillingAddressValidationMessage("");
    setUpdateValidatedBillingAddress(null);
  };

  // For Closing Update Organization Modal
  const handleUpdateModalClose = () => {
    setUpdateOrgFormState(updateOrgEmptyFormState);
    setUpdateDialogOpen(false);
    // Reset validation states
    setUpdateAddressValidationStatus(null);
    setUpdateAddressValidationMessage("");
    setUpdateValidatedAddress(null);
    setUpdateBillingAddressValidationStatus(null);
    setUpdateBillingAddressValidationMessage("");
    setUpdateValidatedBillingAddress(null);
  };

  // For handling form fields of Update Organization Modal
  const handleUpdateOrgInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateOrgFormState({ ...updateOrgFormState, [name]: value });
  };

  // For Validating form of Update Organization Modal
  const isUpdateOrgFormInvalid = () => {
    const isInvalidItems = [
      {
        field: "orgaddress",
        isInvalid: updateOrgFormState.orgaddress === "" ? true : false,
      },
      {
        field: "orgcountry",
        isInvalid: updateOrgFormState.orgcountry === "" ? true : false,
      },
    ];
    const resp = isInvalidItems.filter((item) => item.isInvalid);
    return resp.length > 0;
  };

  //For Submitting data of Update Organization to API
  const handleUpdateOrgFormSubmit = async (e) => {
    e.preventDefault();
    let valid = true;
    let updatedOrg = null;

    // Validate primary address if not already validated
    if (!updateValidatedAddress) {
      const validationResult = await validateAddress(updateOrgFormState.orgaddress, updateOrgFormState.orgcountry, 'update-primary');
      if (!validationResult || !validationResult.isValid) {
        return;
      }
      setUpdateValidatedAddress(validationResult);
    }

    // Validate billing address if provided
    if (updateOrgFormState.orgbillingaddress && !updateValidatedBillingAddress) {
      const validationResult = await validateAddress(updateOrgFormState.orgbillingaddress, updateOrgFormState.orgbillingcountry, 'update-billing');
      if (!validationResult || !validationResult.isValid) {
        return;
      }
      setUpdateValidatedBillingAddress(validationResult);
    }

    valid = !isUpdateOrgFormInvalid();
    console.log(
      "updateOrgFormState :: ",
      updateOrgFormState,
      "Valid :: ",
      valid
    );

    updatedOrg = {
      orgcode: updateOrgFormState.orgcode,
      orgname: updateOrgFormState.orgname,
      orgprimaryname: updateOrgFormState.orgprimaryname,
      orgaddress: updateValidatedAddress.formattedAddress || updateOrgFormState.orgaddress,
      orgcity: updateValidatedAddress.city,
      orgstate: updateValidatedAddress.state,
      orgcountry: updateOrgFormState.orgcountry,
      orgzip: updateValidatedAddress.zip,
      orgbillingname: updateOrgFormState.orgbillingname,
      orgbillingaddress: updateValidatedBillingAddress ? updateValidatedBillingAddress.formattedAddress : updateOrgFormState.orgbillingaddress,
      orgbillingstate: updateValidatedBillingAddress ? updateValidatedBillingAddress.state : updateOrgFormState.orgbillingstate,
      orgbillingcountry: updateOrgFormState.orgbillingcountry,
      orgbillingzip: updateValidatedBillingAddress ? updateValidatedBillingAddress.zip : updateOrgFormState.orgbillingzip,
      orgbillingcity: updateValidatedBillingAddress ? updateValidatedBillingAddress.city : updateOrgFormState.orgbillingcity,
      phonenumber: updateOrgFormState.phoneNumber,
      numUsers: updateOrgFormState.numUsers,
      numAccounts: updateOrgFormState.numAccounts,
      orgScopeEnabled: updateOrgFormState.orgScopeEnabled,
    };

    if (valid) {
      console.log("About to send updatedOrg to API :: ", updatedOrg);
      props.updateOrganization(updatedOrg);
    }
  };

  // For handling form fields of Organization Modal
  const handleExtendDaysInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "extendDays") {
      setExtendDays(value);
    }
  };

  //TODO:
  // For opening Upgrade License Modal
  const handleExtendLicenseModalOpen = (rowData) => {
    console.log("Row Data :: ", rowData);
    let row = { ...rowData };
    setOrgCodeForExtendLicense(rowData.orgcode);
    setExtendLicenseDialogOpen(true);
  };

  const handleExtendLicenseModalClose = () => {
    setExtendLicenseDialogOpen(false);
    setOrgCodeForExtendLicense("");
    setExtendDays("");
  };

  // For Validating form of Organization Modal
  const isExtendLicenseFormInvalid = () => {
    const isInvalidItems = [
      {
        field: "extendDays",
        isInvalid: extendDays === "" || parseInt(extendDays) < 0 ? true : false,
      },
    ];
    const resp = isInvalidItems.filter((item) => item.isInvalid);
    return resp.length > 0;
  };

  //For Submitting data of Update Organization to API
  const handleExtendLicenseFormSubmit = (e) => {
    e.preventDefault();
    let valid = true;
    valid = !isExtendLicenseFormInvalid();
    if (valid) {
      console.log("Submitting data of extending license");
    }
    props.extendFreeLicense({
      days: extendDays,
      orgCode: orgCodeForExtendLicense,
    });
  };

  //For clearing message for extending organization
  let extendFreeLicenseMsg = props.extendFreeLicenseMessage;
  let extendFreeLicenseErr = props.extendFreeLicenseError;
  // Memoized callbacks to be used within useEffect
  const getOrganizationsCb = useCallback(() => {
    props.getOrganizations();
  }, []);

  const clearAllFreeLicenseMessagesCb = useCallback(() => {
    props.clearAllFreeLicenseMessages();
  }, []);
  useEffect(() => {
    console.log("extendFreeLicenseMsg = " + extendFreeLicenseMsg);
    if (extendFreeLicenseMsg) {
      console.log("Inside if, extendFreeLicenseMsg = " + extendFreeLicenseMsg);
      //Close Modal
      setExtendLicenseDialogOpen(false);
      //Clear state variables associated with the form
      clearExtendLicenseFormState();
      // Reload updated organizations data
      clearAllFreeLicenseMessagesCb();
      getOrganizationsCb();
    }
    if (extendFreeLicenseErr) {
      setTimeout(() => {
        clearAllFreeLicenseMessagesCb();
      }, 10000);
    }
  }, [
    extendFreeLicenseMsg,
    extendFreeLicenseErr,
    getOrganizationsCb,
    clearAllFreeLicenseMessagesCb,
  ]);

  const viewCustomLicense = (orgCode) => {
    history.push("/organization/customlicensemanager/" + orgCode);
  };

  const viewAccount = (orgCode) => {
    console.log("View Clicked :: ", orgCode);
    history.push("/organization/account/" + orgCode);
  };

  const handleIaacLicense = (orgCode) => {
    console.log("Iaac License Clicked :: ", orgCode);
    history.push("/organization/iaac/" + orgCode);
  };

  const handleBilling = (orgCode, orgName) => {
    console.log("Billing Clicked :: ", orgCode);
    history.push("/organization/billing/" + orgCode, { orgName });
  };

  const handleActivationClick = (rowData) => {
    console.log("Activation Clicked :: ", rowData.token);
    props.resendOrgOnBoardActionLink(rowData.token);
  };

  // Ensure organizations is always an array
  const organizationsArray = Array.isArray(props.organizations)
    ? props.organizations
    : Object.values(props.organizations || {});

  // Utility function to generate random colors with predefined colors array
  const colors = [
    // Professional, distinct colors
    "#1E88E5",  // Blue
    "#E91E63",  // Pink
    "#43A047",  // Green
    "#FB8C00",  // Orange
    "#8E24AA",  // Purple
    "#F4511E",  // Deep Orange
    "#00ACC1",  // Cyan
    "#5C6BC0",  // Indigo
    "#FDD835",  // Yellow
    "#6D4C41",  // Brown
    "#546E7A",  // Blue Grey
    "#D81B60",  // Pink Dark
    "#00897B",  // Teal
    "#3949AB",  // Indigo Dark
    "#C0CA33",  // Lime
    "#7B1FA2",  // Purple Dark
    "#00BFA5",  // Teal Light
    "#FFB300",  // Amber
    "#D84315",  // Deep Orange Dark
    "#2E7D32",  // Green Dark
  ];

  const getRandomColor = () => {
    return colors[Math.floor(Math.random() * colors.length)];
  };

  // Map MSP names to colors
  const mspColorMap = useMemo(() => {
    const map = {};
    const usedColors = new Set();
    const availableColors = new Set(colors);  // Now colors is defined

    organizationsArray.forEach((org) => {
      if (org.msp && !map[org.orgname]) {
        // Find an unused color
        let color;
        for (const availableColor of availableColors) {
          if (!usedColors.has(availableColor)) {
            color = availableColor;
            break;
          }
        }
        
        // If all colors are used, reuse a random one
        if (!color) {
          color = getRandomColor();
        }

        map[org.orgname] = color;
        usedColors.add(color);
        availableColors.delete(color);
      }
    });
    return map;
  }, [organizationsArray]);

  const MspBadge = ({ color }) => (
    <sup
      style={{
        backgroundColor: color,
        padding: "2px 5px",
        borderRadius: "4px",
        marginLeft: "5px",
        fontSize: "10px",
        color: "#fff",
      }}
    >
      MSP
    </sup>
  );

  const columns = useMemo(
    () => [
      {
        id: "expander",
        header: () => null,
        cell: ({ row }) => null,
      },
      {
        header: "Organization Name",
        accessorKey: "orgname",
        cell: ({ row }) => {
          const orgName = row.original.orgname;
          const isMsp = row.original.msp;
          const badgeColor = mspColorMap[orgName];

          return (
            <div>
              {orgName}
              {isMsp && <MspBadge color={badgeColor} />}{" "}
              {/* MSP badge with dynamic color */}
            </div>
          );
        },
      },
      {
        header: "MSP Name",
        accessorKey: "parentMspName",
        cell: ({ row }) => {
          const mspName = row.original.parentMspName || "NONE";
          const badgeColor = mspColorMap[mspName]; // Get same color for MSP badge

          return (
            <div>
              {mspName}
              {badgeColor && <MspBadge color={badgeColor} />}{" "}
              {/* Show badge if MSP */}
            </div>
          );
        },
      },
      {
        header: "Organization Code",
        accessorKey: "orgcode",
      },
      {
        header: "Actions",
        id: "actions",
        cell: ({ row }) => (
          <div className={classes.actions}>
            {userRole.includes("Admin") && (
              <>
                {/* View Button with Tooltip */}
                <Tooltip title="View Account Details" arrow>
                  <Button
                    variant="contained"
                    onClick={() => viewAccount(row.original.orgcode)}
                  >
                    View Account Details
                  </Button>
                </Tooltip>
                {/* View Billing Button */}
                <Tooltip title="Billing" arrow>
                  <Button
                    variant="contained"
                    onClick={() =>
                      handleBilling(row.original.orgcode, row.original.orgname)
                    }
                  >
                    Billing
                  </Button>
                </Tooltip>

                {/* Edit Buttons with Tooltips */}
                {row.original.orgdescription.startsWith("Free") ? (
                  <Tooltip title="Extend Free Trial" arrow>
                    <IconButton
                      onClick={() => handleExtendLicenseModalOpen(row.original)}
                    >
                      <ExtendIcon style={{ color: "green" }} />
                    </IconButton>
                  </Tooltip>
                ) : null}
                <Tooltip title="View IAAC License" arrow>
                  <IconButton
                    onClick={() => handleIaacLicense(row.original.orgcode)}
                  >
                    <IaacIcon style={{ color: "blue" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="View Custom License" arrow>
                  <IconButton
                    onClick={() => viewCustomLicense(row.original.orgcode)}
                  >
                    <OutboundIcon style={{ color: "orange" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Update Organization" arrow>
                  <IconButton
                    onClick={() => handleUpdateModalOpen(row.original)}
                  >
                    <EditIcon style={{ color: "purple" }} />
                  </IconButton>
                </Tooltip>
                                  {/* Delete Button with Tooltip */}
                  <Tooltip title={(row.original.orgname === "CloudNova Techies" || row.original.orgname === "CloudNova Technologies, LLC") ? "Cannot delete this organization" : "Delete Organization"} arrow>
                    <IconButton
                      onClick={() => handleDeleteClick(row.original)}
                      disabled={row.original.orgname === "CloudNova Techies" || row.original.orgname === "CloudNova Technologies, LLC"}
                    >
                      <DeleteIcon style={{ color: (row.original.orgname === "CloudNova Techies" || row.original.orgname === "CloudNova Technologies, LLC") ? "gray" : "red" }} />
                    </IconButton>
                  </Tooltip>
              </>
            )}
          </div>
        ),
      },
    ],
    [props]
  );

  console.log("props: ", props);

  return (
    <div>
      <AppBar position="static" style={appBarStyles}>
        <Toolbar>
          <Breadcrumbs aria-label="breadcrumb" sx={{ flexGrow: 1 }}>
            <Link component={RouterLink} to="/organization" color="inherit">
              <HomeOutlinedIcon />
            </Link>
            <Typography color="textPrimary">Organization</Typography>
          </Breadcrumbs>
          <div>
            <Button onClick={handleAddModalOpen} style={{ color: "blue" }}>
              Add Organization
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            aria-label="basic tabs example"
          >
            <Tab label="Organizations" {...a11yProps(0)} />
            <Tab label="Pre onboarded Organizations" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={tabIndex} index={0}>
          {props.isGettingOrganizations && (
            <div
              style={{
                display: "flex",
                direction: "column",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                justifyItems: "center",
                height: "100vh",
              }}
            >
              <img src={spinner} width="32px" alt="Spinner" />
            </div>
          )}
          {props.updateOrganizationMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.updateOrganizationMessage}
            </Alert>
          )}
          {props.deleteOrganizationMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.deleteOrganizationMessage}
            </Alert>
          )}
          {props.getOrganizationsMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.getOrganizationsMessage}
            </Alert>
          )}
          {props.registerTrialAccountUserMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.registerTrialAccountUserMessage}
            </Alert>
          )}
          {props.getOrganizationsError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while getting organizations information.
              {JSON.stringify(props.getOrganizationsError.message)}
            </Alert>
          )}
          {props.deleteOrganizationError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while deleting organization.
              {JSON.stringify(props.deleteOrganizationError.message)}
            </Alert>
          )}
          {/* Data grid/table to display organizations */}
          {props.organizations && (
            <OrganizationTable
              data={Object.values(props.organizations)}
              columns={columns}
              viewAccount={props.viewAccount}
              handleExtendLicenseModalOpen={props.handleExtendLicenseModalOpen}
              handleUpdateModalOpen={props.handleUpdateModalOpen}
              deleteOrganization={props.deleteOrganization}
            />
          )}
        </CustomTabPanel>
        <CustomTabPanel value={tabIndex} index={1}>
          <h1>List of Pre Onboarded Organizations</h1>
          <PreOnboardedOrganizationsTable userRole={userRole} />
        </CustomTabPanel>
      </Box>

      {/* Modal to add a organization */}
      <Modal
        className={classes.modal}
        open={addDialogOpen}
        onClose={handleAddModalClose}
      >
        <Box
          className={classes.paper}
          style={{ width: "600px", padding: "20px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2 id="simple-modal-title">Add Organization</h2>
            <IconButton onClick={handleAddModalClose}>
              <CloseIcon />
            </IconButton>
          </div>
          {props.isRegisteringTrialAccountUser && (
            <img src={spinner} width="32px" alt="Spinner" />
          )}
          {props.registerTrialAccountUserError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error:
              {JSON.stringify(props.registerTrialAccountUserError.message)}
            </Alert>
          )}
          <form onSubmit={handleAddOrgFormSubmit} style={{ padding: "20px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="userFirstName"
                  value={userFirstName}
                  label="First Name"
                  onChange={handleAddOrgInputChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="userLastName"
                  value={userLastName}
                  label="Last Name"
                  onChange={handleAddOrgInputChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ marginBottom: "4px", fontWeight: "bold" }}>
                  Contact Number: <span style={{ color: "red" }}>*</span>
                </div>
                <PhoneInput
                  type="text"
                  className={
                    !phonenumberError ? "phone-input" : "phone-input invalid"
                  }
                  name="userPhone"
                  placeholder="Phone"
                  value={userPhone}
                  onChange={handlePhoneChange}
                  onBlur={handlePhoneBlur}
                  required
                />
                {phonenumberError && (
                  <div
                    className="text-danger"
                    style={{
                      fontSize: "80%",
                      marginTop: "0.25rem",
                    }}
                  >
                    {phonenumberError}
                  </div>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="userEmail"
                  value={userEmail}
                  label="Work Email"
                  onChange={handleAddOrgInputChange}
                  required
                  type="email"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="companyName"
                  value={companyName}
                  label="Company Name"
                  onChange={handleAddOrgInputChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  name="registrationType"
                  value={registrationType}
                  onChange={(e) => setRegistrationType(e.target.value)}
                  label="Registration Type"
                  required
                >
                  {["MSP", "MSPWARF", "ASSISTED"].map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  fullWidth
                  options={countryList}
                  getOptionLabel={(option) => option?.name || ""}
                  isOptionEqualToValue={(option, value) => option.name === value || option.name === value?.name}
                  value={countryList.find(c => c.name === userCountry) || null}
                  onChange={(event, newValue) => {
                    handleAddOrgInputChange({
                      target: { name: "userCountry", value: newValue?.name || "" },
                    });
                    setAddressValidationStatus(null);
                    setAddressValidationMessage("");
                    setValidatedAddress(null);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Country" required fullWidth />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="userAddress"
                  value={userAddress}
                  label="Address"
                  onChange={(e) => {
                    handleAddOrgInputChange(e);
                    setAddressValidationStatus(null);
                    setAddressValidationMessage("");
                    setValidatedAddress(null);
                  }}
                  onBlur={() => validateAddress(userAddress, userCountry)}
                  error={addressValidationStatus === "invalid"}
                  disabled={!userCountry}
                  placeholder={!userCountry ? "Please select a country first" : "Enter complete address"}
                  required
                  helperText={addressValidationMessage}
                  InputProps={{
                    endAdornment: addressValidationStatus === "valid" && (
                      <i
                        className="mdi mdi-check-circle"
                        style={{
                          position: "absolute",
                          right: "10px",
                          color: "green",
                        }}
                      />
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="noOfAccounts"
                  value={noOfAccounts}
                  label="No of Accounts"
                  onChange={handleAddOrgInputChange}
                  required
                  type="number"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="noOfUsers"
                  value={noOfUsers}
                  label="Number of Users"
                  onChange={handleAddOrgInputChange}
                  required
                  type="number"
                />
              </Grid>
              <Grid item xs={12} >
                <TextField
                  fullWidth
                  name="userComments"
                  value={userComments}
                  label="User Comments (optional)"
                  onChange={handleAddOrgInputChange}
                />
              </Grid>
            </Grid>
            <Box mt={2}>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                type="submit"
                disabled={
                  isAddOrgFormInvalid() || props.isRegisteringTrialAccountUser
                }
              >
                Send On-boarding Link
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>

      {/* Update Organization Modal */}
      <Modal
        className={classes.modal}
        open={updateDialogOpen}
        onClose={handleUpdateModalClose}
      >
        <Box className={classes.paper}>
          <div className={classes.header}>
            <Typography variant="h6" className={classes.title}>
              Update Organization
            </Typography>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleUpdateModalClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          {props.isUpdatingOrganization && (
            <img src={spinner} width="32px" alt="Spinner" />
          )}
          {props.updateOrganizationError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while Updating an organization. Error:
              {JSON.stringify(props.updateOrganizationError.message)}
            </Alert>
          )}

          <form onSubmit={handleUpdateOrgFormSubmit}>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Primary Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  {/* Organization Name */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Organization Name"
                      name="orgname"
                      value={updateOrgFormState.orgname}
                      onChange={handleUpdateOrgInputChange}
                      variant="outlined"
                      required
                    />
                  </Grid>

                  {/* Registration Type */}
                  {/* <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      fullWidth
                      label="Registration Type"
                      name="registrationType"
                      value={updateOrgFormState.registrationType || ""}
                      onChange={handleUpdateOrgInputChange}
                      variant="outlined"
                      required
                    >
                      {["MSP", "MSPWARF", "ASSISTED"].map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid> */}

                  {/* Primary Contact Person Name */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Primary Contact Person Name"
                      name="orgprimaryname"
                      value={updateOrgFormState.orgprimaryname}
                      onChange={handleUpdateOrgInputChange}
                      variant="outlined"
                      required
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Contact Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      fullWidth
                      options={countryList}
                      getOptionLabel={(option) => option?.name || ""}
                      isOptionEqualToValue={(option, value) => option.name === value || option.name === value?.name}
                      value={countryList.find(c => c.name === updateOrgFormState.orgcountry) || null}
                      onChange={(event, newValue) => {
                        handleUpdateOrgInputChange({
                          target: { name: "orgcountry", value: newValue?.name || "" },
                        });
                        setUpdateAddressValidationStatus(null);
                        setUpdateAddressValidationMessage("");
                        setUpdateValidatedAddress(null);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Country" required fullWidth variant="outlined" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Address"
                      name="orgaddress"
                      value={updateOrgFormState.orgaddress}
                      onChange={(e) => {
                        handleUpdateOrgInputChange(e);
                        setUpdateAddressValidationStatus(null);
                        setUpdateAddressValidationMessage("");
                        setUpdateValidatedAddress(null);
                      }}
                      onBlur={() => validateAddress(updateOrgFormState.orgaddress, updateOrgFormState.orgcountry, 'update-primary')}
                      error={updateAddressValidationStatus === "invalid"}
                      disabled={!updateOrgFormState.orgcountry}
                      placeholder={!updateOrgFormState.orgcountry ? "Please select a country first" : "Enter complete address"}
                      variant="outlined"
                      required
                      helperText={updateAddressValidationMessage}
                      InputProps={{
                        endAdornment: updateAddressValidationStatus === "valid" && (
                          <i
                            className="mdi mdi-check-circle"
                            style={{
                              position: "absolute",
                              right: "10px",
                              color: "green",
                            }}
                          />
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PhoneInput
                      international
                      defaultCountry="US"
                      value={updateOrgFormState.phoneNumber}
                      onChange={(value) =>
                        handleUpdateOrgInputChange({
                          target: { name: "phoneNumber", value },
                        })
                      }
                      inputComponent={TextField}
                      placeholder="Phone"
                      required
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Billing Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Billing Name"
                      name="orgbillingname"
                      value={updateOrgFormState.orgbillingname}
                      onChange={handleUpdateOrgInputChange}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      fullWidth
                      options={countryList}
                      getOptionLabel={(option) => option?.name || ""}
                      isOptionEqualToValue={(option, value) => option.name === value || option.name === value?.name}
                      value={countryList.find(c => c.name === updateOrgFormState.orgbillingcountry) || null}
                      onChange={(event, newValue) => {
                        handleUpdateOrgInputChange({
                          target: { name: "orgbillingcountry", value: newValue?.name || "" },
                        });
                        setUpdateBillingAddressValidationStatus(null);
                        setUpdateBillingAddressValidationMessage("");
                        setUpdateValidatedBillingAddress(null);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Billing Country" fullWidth variant="outlined" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Billing Address"
                      name="orgbillingaddress"
                      value={updateOrgFormState.orgbillingaddress}
                      onChange={(e) => {
                        handleUpdateOrgInputChange(e);
                        setUpdateBillingAddressValidationStatus(null);
                        setUpdateBillingAddressValidationMessage("");
                        setUpdateValidatedBillingAddress(null);
                      }}
                      onBlur={() => {
                        if (updateOrgFormState.orgbillingaddress && updateOrgFormState.orgbillingcountry) {
                          validateAddress(updateOrgFormState.orgbillingaddress, updateOrgFormState.orgbillingcountry, 'update-billing');
                        }
                      }}
                      error={updateBillingAddressValidationStatus === "invalid"}
                      disabled={!updateOrgFormState.orgbillingcountry}
                      placeholder={!updateOrgFormState.orgbillingcountry ? "Please select a billing country first" : "Enter complete billing address"}
                      variant="outlined"
                      helperText={updateBillingAddressValidationMessage}
                      InputProps={{
                        endAdornment: updateBillingAddressValidationStatus === "valid" && (
                          <i
                            className="mdi mdi-check-circle"
                            style={{
                              position: "absolute",
                              right: "10px",
                              color: "green",
                            }}
                          />
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Max Users and Accounts Allowed</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Number of Users"
                      name="numUsers"
                      type="number"
                      value={updateOrgFormState.numUsers}
                      onChange={handleUpdateOrgInputChange}
                      variant="outlined"
                      inputProps={{ maxLength: 5 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Number of Accounts"
                      name="numAccounts"
                      type="number"
                      value={updateOrgFormState.numAccounts}
                      onChange={handleUpdateOrgInputChange}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <div style={{ marginTop: "20px" }}>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                type="submit"
              >
                Update Organization
              </Button>
            </div>
          </form>
        </Box>
      </Modal>

      {/* Extend License Modal */}
      <Modal
        className={classes.modal}
        open={extendLicenseDialogOpen}
        onClose={handleExtendLicenseModalClose}
      >
        <Box className={classes.paper}>
          <h2 id="simple-modal-title">Extend Free License</h2>
          {/* TODO: */}
          {props.isExtendingFreeLicense && (
            <img src={spinner} width="32px" alt="Spinner" />
          )}
          {props.extendFreeLicenseError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while extending free license. Error:
              {JSON.stringify(props.extendFreeLicenseError)}
            </Alert>
          )}

          <AvForm className="form-horizontal">
            <Row>
              <Col lg="12">
                <FormGroup>
                  <AvField
                    name="extendDays"
                    value={extendDays}
                    placeholder="Number of days to extend"
                    type="number"
                    id="basicpill-ExtendDays-input"
                    className={"form-control"}
                    onChange={handleExtendDaysInputChange}
                    min={1}
                    errorMessage="Enter Number of days to extend as a positive number"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col lg="12">
                <FormGroup>
                  <Button
                    color="primary"
                    className="w-md waves-effect waves-light"
                    type="submit"
                    disabled={
                      isExtendLicenseFormInvalid() ||
                      props.isExtendingFreeLicense
                    }
                    //onValidSubmit={this.handleSubmit}
                    onClick={(e) => {
                      handleExtendLicenseFormSubmit(e);
                      // setTimeout(this.handleConfirmation, 800);
                    }}
                  >
                    Extend License
                  </Button>
                </FormGroup>
              </Col>
            </Row>
          </AvForm>
        </Box>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-confirmation-modal"
        aria-describedby="confirm-delete-organization"
      >
        <div className={styles.modal}>
          <h2 id="delete-confirmation-modal">
            Delete Organization: {orgToDelete?.orgname}
          </h2>
          <p id="confirm-delete-organization">
            Are you sure you want to delete {orgToDelete?.orgname}? This action cannot be undone.
          </p>
          <div className={styles.modalButtons}>
            <Button onClick={handleDeleteConfirm} color="secondary">
              Delete
            </Button>
            <Button onClick={handleCloseDeleteModal} color="primary">
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    isAddingOrganization,
    addOrganizationError,
    addOrganizationMessage,

    isUpdatingOrganization,
    updateOrganizationError,
    updateOrganizationMessage,

    isDeletingOrganization,
    deleteOrganizationError,
    deleteOrganizationMessage,

    isGettingOrganizations,
    getOrganizationsError,
    getOrganizationsMessage,
    organizations,

    // isGettingPreOnBoardedOrganizations,
    // getPreOnBoardedOrganizationsError,
    // getPreOnBoardedOrganizationsMessage,
    // preOnBoardedOrganizations,

    // isResendingOrgOnBoardActivationLink,
    // resendOrgOnBoardActivationLinkError,
    // resendOrgOnBoardActivationLinkMessage,

    isRegisteringTrialAccountUser,
    registerTrialAccountUserError,
    registerTrialAccountUserMessage,
  } = state.organization;
  const {
    isExtendingFreeLicense,
    extendFreeLicenseMessage,
    extendFreeLicenseError,
  } = state.freeLicense;

  return {
    isAddingOrganization,
    addOrganizationError,
    addOrganizationMessage,

    isUpdatingOrganization,
    updateOrganizationError,
    updateOrganizationMessage,

    isDeletingOrganization,
    deleteOrganizationError,
    deleteOrganizationMessage,

    isGettingOrganizations,
    getOrganizationsError,
    getOrganizationsMessage,
    organizations,

    // isGettingPreOnBoardedOrganizations,
    // getPreOnBoardedOrganizationsError,
    // getPreOnBoardedOrganizationsMessage,
    // preOnBoardedOrganizations,

    // isResendingOrgOnBoardActivationLink,
    // resendOrgOnBoardActivationLinkError,
    // resendOrgOnBoardActivationLinkMessage,

    isRegisteringTrialAccountUser,
    registerTrialAccountUserError,
    registerTrialAccountUserMessage,

    isExtendingFreeLicense,
    extendFreeLicenseMessage,
    extendFreeLicenseError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addOrganization: (organization) => {
      dispatch(addOrganization(organization));
    },
    getOrganizations: () => {
      dispatch(getOrganizations());
    },

    // getPreOnBoardedOrganizations: () => {
    //   dispatch(getPreOnBoardedOrganizations());
    // },
    // resendOrgOnBoardActionLink: (token) => {
    //   dispatch(resendOrgOnBoardActionLink(token));
    // },
    updateOrganization: (organization) => {
      dispatch(updateOrganization(organization));
    },
    deleteOrganization: (orgCode) => {
      dispatch(deleteOrganization(orgCode));
    },
    registerTrialAccountUser: (user) => {
      dispatch(registerTrialAccountUser(user));
    },
    clearAllMessages: () => {
      dispatch(clearAllMessages());
    },
    extendFreeLicense: (data) => {
      dispatch(extendFreeLicense(data));
    },
    clearAllFreeLicenseMessages: () => {
      dispatch(clearAllFreeLicenseMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Organization);
